import React from 'react';
import deviceEvents from "./../../Utils";
import WithdrawalCon from "./../../../Components/M23/Withdrawal";
import LoadSpinner from "./../../Common/LoadSpinner";

import LB from "./LB";
import CCW from "./CCW";


import translate from "./../../../lib/translate/TranslateJs";
import { PhoneEmailVerification } from './../../Component/WithdrawModal'

function MethodButtons(props) {
    return <div>
        {props.payMethods.map((v, i) => (
            <div
                key={"pay_method_" + i}
                className={props.currCode === v.code ? "active" : ""}
                onClick={() => {props.onClick(v.code)}}
            >
                {/* <Image
                    resizeMode="contain"
                    source={isActive ? require("./../../Imgs/ExampleActive.png") : require("./../../Imgs/Example.png")}
                    className={styles.place}
                /> */}
                <span>{v.name}</span>
            </div>
        ))}
    </div>
}


function Children(key, params) {
    // { AP, BC, BCM, CC, CTC, JDP, LB, OA, PPB, QQ, SR, UP, WC, WCLB }
    const ChildrenDOM = {
        LB: <LB {...params} />,
        CCW: <CCW {...params} />
    }

    return ChildrenDOM[key];
}


export default function Withdrawal(props) {
    return <WithdrawalCon
        setAnnouncement={props.setAnnouncement}
        setCurrKey={props.setCurrKey}
        setPayMethods={props.setPayMethods}
        setPayMethodChange={props.setPayMethodChange}
        LoadSpinner={LoadSpinner}
        MethodButtons={MethodButtons}
        PayListDOM={Children}
        PhoneEmailVerification={PhoneEmailVerification}
        // payListFormat={payListFormat} // M3充值方式列表不进行格式化处理
        deviceEvents={deviceEvents}
    />
}
